import { render, staticRenderFns } from "./JobCategory.vue?vue&type=template&id=ef2b34ca&scoped=true"
import script from "./JobCategory.vue?vue&type=script&lang=js"
export * from "./JobCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2b34ca",
  null
  
)

export default component.exports